import { render, staticRenderFns } from "./GrupoUsuarios.vue?vue&type=template&id=7541f561&scoped=true&lang=pug&"
import script from "./GrupoUsuarios.vue?vue&type=script&lang=js&"
export * from "./GrupoUsuarios.vue?vue&type=script&lang=js&"
import style0 from "./GrupoUsuarios.vue?vue&type=style&index=0&id=7541f561&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7541f561",
  null
  
)

export default component.exports